// Configuration for the store
export let STORE_ID = 1;
export const setStoreId = (id) => { STORE_ID = id; };

// Default locale
export const DEFAULT_LOCALE = 'ar';
export const FALLBACK_LOCALE = 'fr';

export const API_BASE_URL = 'https://zoxcom.accessoiresherbin.com/backend/api.php';
